/**
 * Created by Mitch Hess on 04/06/2019.
 */

var webSiteUrl = window.location.hostname;
var webSite = "na";
var utm_source = "";
var wsc="";
var fRate = .0275;
var lowestRate = bestFinanceRate; //new lowest rate on credit key/equipmoney
var itemSku = "";
var itemqty = "1";
var itemtitle = "";
if (webSiteUrl.indexOf("cleanfreak.com") >= 0){
    website = "cf";
    utm_source = "rcwe9em";
}else if (webSiteUrl.indexOf("airmovers.com") >= 0){
    website = "am"
    wsc = "air";
    utm_source = "rcwe9em";
}else if (webSiteUrl.indexOf("carpetextractors.com") >= 0){
    website = "ce"
    wsc = "carpet";
    utm_source = "rcwe9em";
}else if (webSiteUrl.indexOf("floorbuffers.com") >= 0){
    website = "fb";
    wsc = "floor";
    utm_source = "rcwe9em";
}else if (webSiteUrl.indexOf("floorscrubbers.com") >= 0){
    website = "fs";
    wsc = "scrubber";
    utm_source = "rcwe9em";
}function getLinkv3(sku,cost,title, qty=1){
    title = encodeURIComponent(title.trim());
    title = title.replace(/'/g, '%27');

    var LowestRateTotal = cost*lowestRate ;
    var PaymentOptionPopCall = 'getPaymentOptions(event,'+cost+',\''+sku+'\',\''+qty+'\',\''+title+'\');';

    //pop the popup if finance equals pop in url
    const urlParams = new URLSearchParams(window.location.search);
    if(urlParams.get('finance') == 'pop'){
        //getPaymentOptions(event,cost,sku,qty,'');
    };
    
    

    var LSlink = '<div onclick="'+PaymentOptionPopCall+'" style="width:120px" class="financebtn product-form--atc-button main-atc-button thinbtn" onclick="" >Apply Now</div>';


    return LSlink;
}

function checkCost(cost) {
    cost = cost.replace(/[$,]/g, ''); // remove characters
    cost = cost.trim();
    if (cost > 999.99){
        return cost;
    }else{
        return false;
    }
}

/*Product page functions*/
function productPageCheck(type){
    //simple and variations
    var itempricing = checkCost(jQuery(".price__current .money").first().text());

    if (itempricing != false && !isNaN(itempricing)) {

        //Clear container if filled
        jQuery(".product-main .finance-wrapper").html("");

            itemSku = jQuery(".product-main .product-detail-sku span:visible").first().text();
            itemqty = jQuery(".product-main .qtybox .qty").val();
            if(isNaN(itemqty)){
                itemqty = 1;
            }
            itempricing = itempricing*itemqty;
            itemtitle = jQuery(".product-main .product-title").first().text();

            

            jQuery(".product-main .finance-wrapper").append(getLinkv3(itemSku, itempricing, itemtitle, itemqty));

        jQuery(".product-main .product-form--finance-atc-button").html(getLinkv3(itemSku, itempricing, itemtitle, itemqty)).show();
        jQuery(".product-main .product-form--finance-atc-button .finance-link").html("Financing Available");
    }
}

function cartPageCheck(){
    
    
    var cartCost = checkCost(jQuery(".cart-final-total .cart-subtotal .money").first().text());
    var cartSkus = "";
    var cartQtys = "";
    var carttitles = "";
    
    var cartLowestRateTotal = cartCost*lowestRate ;
    var cartPaymentOptionPopCall = 'getPaymentOptions(event,'+cartCost+',\''+cartSkus+'\',\''+cartQtys+'\',\''+carttitles+'\',\'cart\');';

    var cartLink = '<div onclick="'+cartPaymentOptionPopCall+'" class="lsb2 finance-link">Finance for as low as <strong>$'+Math.ceil(cartLowestRateTotal)+'/month</strong> <img style="width:105px; float:right; margin-top:1px" src="//www.cleanfreak.com/cdn/shop/files/quickspark-v2.png?v=5543910152442945816" alt="QuickSpark Financing"/></div><div class="clearer"></div>';

    if (cartCost >= 1000){
        jQuery(".cart-checkout .finance-wrapper").html("");
        jQuery(".cart-checkout .finance-wrapper").append(cartLink);
    }else{
        jQuery(".cart-checkout .finance-wrapper").html("");
    }
}


jQuery(document).ready(function() {
    /*Product pages***/
    if (jQuery('.sitemain-product').length > 0) {
        /*Simple, Variation, bundle checks***/
        if (jQuery('.options-selection__select').length > 0) {
            // Variation/variant
            setTimeout(function(){productPageCheck("variant");},250);
                jQuery(".options-selection__select select").change(function() {
                    /* must run after custom.js line 254 **/
                        setTimeout(function(){productPageCheck("variant");},305);
                });
            /* qty box trigger **/
            jQuery(".product-main .qtybox .qty").change(function() {
                setTimeout(function(){productPageCheck("variant");},100);
            });
            jQuery(".product-main .qtybox input").on( "click", function() {
                setTimeout(function(){productPageCheck("variant");},100);
            });
        }else{
            
            productPageCheck("simple");
            /* qty box trigger **/
            jQuery(".product-main .qtybox .qty").change(function() {
                setTimeout(function(){productPageCheck("simple");},100);
            });
            jQuery(".product-main .qtybox input").on( "click", function() {
                setTimeout(function(){productPageCheck("simple");},100);
            });
        }
    }

    /*Solr and category pages***/
    if (jQuery('.catalog-category-view').length > 0 || jQuery('.collection--section').length > 0 || jQuery('.catalogsearch-result-index').length > 0) {
        setTimeout(function(){
            jQuery( ".ais-hit.ais-product" ).each(function() {
                var itempricing = false;
                    if (jQuery(this).find(".norm-price span").length > 0) {
                        itempricing = checkCost(jQuery(this).find(".norm-price span").text());
                        if (jQuery(this).find('.norm-price span').length > 0) {
                            itempricing = checkCost(jQuery(this).find(".norm-price span").text());
                        }
                    }
                    

                if (itempricing != false) {
                        itemSku = jQuery(this).find(".product-detail-sku span").text().trim();
                        itemtitle = jQuery(this).find(".ais-hit--title span").text().trim();
                    jQuery(this).find(".search-finance-wrapper").append(getLinkv3(itemSku, itempricing, itemtitle,1));
                }
            });
        },2050);
    }

    /*Cart page***/
    if (jQuery('.template-cart').length > 0){
        setTimeout(function(){cartPageCheck();},250);
    }


});
